import 'css-chunksrc/feature/payment/DuplicateCardConfirmationModal.module.scss';export default {
  "content": "DuplicateCardConfirmationModal_content",
  "message": "DuplicateCardConfirmationModal_message"
};